import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-175f6340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auto-success" }

import { useRoute } from 'vue-router'
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

return (_ctx: any,_cache: any) => {
  const _component_el_result = _resolveComponent("el-result")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_result, {
      icon: "success",
      title: `【${_unref(route).query.shopName}】${_unref(t)('授权成功')}!`
    }, null, 8, ["title"])
  ]))
}
}

})